import { Injectable } from "@angular/core";
import { HttpHelperService } from "@services/http-helper.service";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class NotificationApiService {
  constructor(private readonly httpHelperService: HttpHelperService) {}

  public getNotificationList(payload: {
    userId: string;
    page: number;
    size: number;
  }): Observable<any> {
    return this.httpHelperService.get(
      "/user/notification/list",
      payload as any,
    );
  }

  public markAsRead(payload: any): Observable<any> {
    return this.httpHelperService.post("/notification/save", payload);
  }
}
